import script from "./RequestWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestWindow.vue?vue&type=script&setup=true&lang=js"

import "./RequestWindow.vue?vue&type=style&index=0&id=5c1efbda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1efbda"]])

export default __exports__